import { NgModule } from '@angular/core';
import {CustomMaterialModule} from '@app/core/material.module';
import { CommonModule } from '@angular/common';
import { SelectionListComponent } from '../component/selection-list.component';
import {InputSearchModule} from '@components/input-search/input-search.module';
import {PanelTitleModule} from '@components/panel-title/panel-title.module';
import {SkeletonDirectiveModule} from '../../../directives/skeleton/skeleton-directive.module';
import {GlobalModule} from '@app/core/global.module';
import {HighlightModule} from '../../../directives/highlight/highlight.module';
import {ShowTooltipModule} from '../../../directives/show-tooltip/show-tooltip.module';
import {CustomScrollDirective} from '@directives/custom-scroll/custom-scroll.directive';

@NgModule({
    declarations: [
        SelectionListComponent
    ],
    exports: [
        SelectionListComponent
    ],
    imports: [
        CommonModule,
        InputSearchModule,
        PanelTitleModule,
        SkeletonDirectiveModule,
        CustomMaterialModule,
        GlobalModule,
        HighlightModule,
        CustomScrollDirective
    ]
})
export class SelectionListModule { }
